import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {HttpService} from "../http.service";
import {ContactFormRequest} from "../../shared/model/request/contact.model";
import {ApiResponse} from "../../shared/model/response/ApiResponse";
import {HttpUtils} from "../../shared/utils/http.utils";
import {FeedbackFilterRequestModel} from "../../shared/model/request/feedback-filter-request.model";
import {FeedbackResponse} from "../../shared/model/response/feedback-response";
import {DatePipe} from "@angular/common";

@Injectable({providedIn: "root"})
export class FeedbackService {

  private version = "/api/v1/"
  private host = environment.host + this.version
  url: string = this.host + "feedbacks"

  constructor(private genericHttp: HttpService, private datePipe: DatePipe) {
  }

  postContact(contactForm: ContactFormRequest): Observable<any> {
    return this.genericHttp.post(this.url, contactForm);
  }

  page(page: number = 0, filters: FeedbackFilterRequestModel): Observable<ApiResponse<FeedbackResponse[]>> {

    //fix date
    if (filters.creationDate) {
      filters.creationDate = this.datePipe.transform(filters.creationDate, 'yyyy-MM-dd');
    }

    let params = HttpUtils.convertObjectToParam(filters).append("page", page)

    return this.genericHttp.get(this.url, {params, shouldShowLoading: true});
  }

  terminateFeedback(id: number) {
    const url = this.url.concat("/", id.toString(), "/status")
    return this.genericHttp.patch(url, null, {shouldShowLoading: true})
  }
}
